// src/views/PublicMaintenanceGate.jsx
import { useState, useEffect } from "react";
import { publicSiteWebService } from "../services/publicSiteWebService";
import { useAuth } from "../context/AuthContext";
import MaintenancePage from "./MaintenancePage";

export default function PublicMaintenanceGate({ children }) {
  const { user } = useAuth();
  const [checking, setChecking] = useState(true);
  const [params, setParams] = useState(null);

  useEffect(() => {
    publicSiteWebService.getPublicData()
      .then(data => setParams(data.parametres))
      .catch(() => {
        // En cas d'échec, on laisse passer plutôt que de bloquer tout le site
        setParams(null);
      })
      .finally(() => setChecking(false));
  }, []);

  // Les utilisateurs connectés (admin, etc.) ne sont jamais bloqués par la maintenance
  if (user) return children;

  // Pendant la vérification, on affiche le contenu normal (évite un flash de page maintenance)
  if (checking) return children;

  if (params?.mode_maintenance) {
    return <MaintenancePage params={params} />;
  }

  return children;
}